// 覚醒王の顔の紫の溜めの光 (2026-10-27 作者「戴冠獣の紫の顔のあたりに出る溜めのエフェクトが引き継がれているが、それは消してほしい。大抵の技に混ざり込んでいる」)。
//   既定 = 覚醒王は顔の光の基層 (render.ts BOSS_BASE_SOUL_GLOW_MULT) も、粒が吸い込まれる合図 (BOSS_PARRY_CUE) も出さない。予告は体と得物の動きで見せる。
//   戴冠獣 (dream-hound) は今のまま。大暴れのピカン (drawChoreoGlint)・致命の紫は別の物なので残す。
//   DEV ?awokenFaceGlow=old で前 (基層 1・合図 0.55) へ戻す。
let faceGlowOld = false
export function setAwokenFaceGlow(v: string | null): boolean {
  faceGlowOld = v === 'old'
  return faceGlowOld
}
export function awokenFaceGlowOld(): boolean { return faceGlowOld }
/** 覚醒王の顔の光の基層の倍率 (前 = 1)。 */
export function awokenBaseGlowMult(): number { return faceGlowOld ? 1 : 0 }
/** 覚醒王の粒が吸い込まれる合図の濃さ (前 = 0.55)。 */
export function awokenParryCue(): number { return faceGlowOld ? 0.55 : 0 }
